define("shared/utils/constants/ada-campaigns", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.VIEWED_CHECKOUT_EXPIRY_IN_DAYS = _exports.TrackEventName = _exports.CampaignKey = _exports.CacheEventName = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  const VIEWED_CHECKOUT_EXPIRY_IN_DAYS = 2;
  _exports.VIEWED_CHECKOUT_EXPIRY_IN_DAYS = VIEWED_CHECKOUT_EXPIRY_IN_DAYS;
  var TrackEventName;
  _exports.TrackEventName = TrackEventName;

  (function (TrackEventName) {
    TrackEventName["TransactionCompleted"] = "transaction_completed";
  })(TrackEventName || (_exports.TrackEventName = TrackEventName = {}));

  var CacheEventName;
  _exports.CacheEventName = CacheEventName;

  (function (CacheEventName) {
    CacheEventName["ViewedCheckout"] = "viewed-checkout";
    CacheEventName["PurchasedPlan"] = "purchased-plan";
  })(CacheEventName || (_exports.CacheEventName = CacheEventName = {}));

  var CampaignKey;
  _exports.CampaignKey = CampaignKey;

  (function (CampaignKey) {
    CampaignKey["PaidToUpgrade"] = "Paid_to_upgrade";
    CampaignKey["FreeToTrial"] = "Free_to_Trail";
    CampaignKey["FreeToPaid"] = "Free_to_Paid";
    CampaignKey["None"] = "";
    CampaignKey["RefreshCredentials"] = "Refresh_Credentials";
  })(CampaignKey || (_exports.CampaignKey = CampaignKey = {}));
});